import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Formarea = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="bg-gray-100 py-16 lg:py-24 relative overflow-hidden">
      {/* Background Pattern */}

      <div className="containers mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 max-w-7xl mx-auto">
          {/* Left Side - Contact Form */}
          <div
            className="order-2 lg:order-1"
            data-aos="fade-right"
          >
            {/* Form Header */}
            <div className="mb-8">
              <p className="text-gray-500 text-sm uppercase tracking-wider mb-2">
                Contact With Us
              </p>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                Drop Us a Line
              </h2>
            </div>

            {/* Contact Form */}
            <div className="space-y-6">
              {/* Name Input */}
              <div data-aos="fade-up" data-aos-delay="100">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full px-6 py-4 bg-white rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none text-gray-700 placeholder-gray-400"
                />
              </div>

              {/* Email Input */}
              <div data-aos="fade-up" data-aos-delay="200">
                <input
                  type="email"
                  placeholder="Your Email"
                  className="w-full px-6 py-4 bg-white rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none text-gray-700 placeholder-gray-400"
                />
              </div>

              {/* Subject Input */}
              <div data-aos="fade-up" data-aos-delay="300">
                <input
                  type="text"
                  placeholder="Subject"
                  className="w-full px-6 py-4 bg-white rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none text-gray-700 placeholder-gray-400"
                />
              </div>

              {/* Message Textarea */}
              <div data-aos="fade-up" data-aos-delay="400">
                <textarea
                  rows="6"
                  placeholder="Your Message"
                  className="w-full px-6 py-4 bg-white rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none text-gray-700 placeholder-gray-400 resize-none"
                ></textarea>
              </div>

              {/* Submit Button */}
              <div data-aos="zoom-in" data-aos-delay="500">
                <button
                  type="button"
                  className="bg-gray-800 hover:bg-gray-900 text-white font-semibold px-8 py-4 rounded-lg transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
                >
                  Send Your Message
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Contact Info */}
          <div
            className="order-1 lg:order-2"
            data-aos="fade-left"
          >
            {/* Hero Image Section */}
            <div className="bg-gray-800 rounded-2xl p-8 lg:p-12 mb-8 relative overflow-hidden">
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-4 right-4 w-20 h-20">
                  <svg viewBox="0 0 100 100" className="w-full h-full">
                    <circle
                      cx="50"
                      cy="50"
                      r="45"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                    <circle
                      cx="50"
                      cy="50"
                      r="30"
                      stroke="white"
                      strokeWidth="1"
                      fill="none"
                    />
                    <circle
                      cx="50"
                      cy="50"
                      r="15"
                      stroke="white"
                      strokeWidth="1"
                      fill="none"
                    />
                  </svg>
                </div>

                <div className="absolute bottom-4 left-4 w-16 h-16">
                  <svg viewBox="0 0 100 100" className="w-full h-full">
                    <polygon
                      points="50,10 90,90 10,90"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                </div>
              </div>

              {/* Lightbulb Icon */}
              <div className="flex items-center mb-6 relative z-10">
                <div className="bg-blue-500 rounded-full p-4 mr-4">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.477.859h4z" />
                  </svg>
                </div>
                <h3 className="text-white text-xl lg:text-2xl font-bold">
                  It's right time to make <br /> something new
                </h3>
              </div>
            </div>

            {/* Contact Without Hesitate */}
            <div
              className="mb-8"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
                Contact Without Hesitate
              </h3>
            </div>

            {/* Contact Information */}
            <div className="space-y-6">
              {/* Phone */}
              <div
                className="flex items-center"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="bg-blue-400 rounded-full p-4 mr-6 flex-shrink-0">
                  📞
                </div>
                <div>
                  <p className="text-gray-600 mb-1">Call Us Anytime</p>
                  <p className="text-xl lg:text-2xl font-bold text-gray-900">
                    +91 9825131393
                  </p>
                </div>
              </div>

              {/* Email */}
              <div
                className="flex items-center"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="bg-gray-300 rounded-full p-4 mr-6 flex-shrink-0">
                  📧
                </div>
                <div>
                  <p className="text-gray-600 mb-1">Write to Us</p>
                  <p className="text-xl lg:text-2xl font-bold text-gray-900">
                    info@dynamicsoftlink.com
                  </p>
                </div>
              </div>

              {/* Location */}
              <div
                className="flex items-center"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="bg-gray-300 rounded-full p-4 mr-6 flex-shrink-0">
                  📍
                </div>
                <div>
                  <p className="text-gray-600 mb-1">Our Location</p>
                  <p className="text-xl lg:text-2xl font-bold text-gray-900">
                    402, Empire State Building, Near Udhna Darwaja, Ring Road, Surat 395002
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formarea;
